var React = require('react');

function TargetInline (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"style":{"strokeWidth":"25"},"cx":"390.267","cy":"328.244","rx":"221.181","ry":"221.181","key":0},React.createElement("title",null,"Circle")),React.createElement("line",{"style":{"strokeLinecap":"round","strokeWidth":"40"},"x1":"291.476","y1":"427.035","x2":"489.058","y2":"229.453","key":1}),React.createElement("line",{"style":{"strokeLinecap":"round","strokeWidth":"40"},"x1":"291.476","y1":"229.453","x2":"489.058","y2":"427.035","key":2})]);
}

TargetInline.displayName = "TargetInline";

TargetInline.defaultProps = {"viewBox":"140.2671356201172 78.2442626953125 500 500"};

module.exports = TargetInline;

TargetInline.default = TargetInline;



//////////////////
// WEBPACK FOOTER
// ./components/Target/target.inline.svg
// module id = 484
// module chunks = 0